// extracted by mini-css-extract-plugin
module.exports = {"container":"Opcao_container__3B1UN","opcaoMenuOpcoes":"Opcao_opcaoMenuOpcoes__1nV5z","itensContainer":"Opcao_itensContainer__wF8so","areaDroparItem":"Opcao_areaDroparItem__1lazl"};